import api from './index'
import request from '@/utils/request'

/**
 * @description 门店列表查询
 */
export function getShopList (data) {
  return request({
    url: `${api.getShopList}`,
    method: 'post',
    data
  })
}

/**
 * @description 门店编辑
 */
export function editShop (data) {
  return request({
    url: `${api.editShop}`,
    method: 'post',
    data
  })
}

/**
 * @description 门店详情查询
 */
export function getShopInfo (params) {
  return request({
    url: `${api.getShopInfo}`,
    method: 'get',
    params
  })
}

/**
 * @description 变更收款账号
 */
export function updateMerchantId (data) {
  return request({
    url: `${api.updateMerchantId}`,
    method: 'post',
    data
  })
}

/**
 * @description 加盟商列表查询
 */
export function getPartnerInfo (params) {
  return request({
    url: `${api.getPartnerInfo}`,
    method: 'get',
    params
  })
}

/**
 * @description 区域列表查询
 */
export function getZoneInfo (params) {
  return request({
    url: `${api.getZoneInfo}`,
    method: 'get',
    params
  })
}

/**
 * @description 品牌列表接口
 */
export function getBrandList (data) {
  return request({
    url: `${api.getBrandList}`,
    method: 'get',
    data
  })
}

/**
 * @description 品牌详情接口
 */
export function getBrandDetail (params) {
  return request({
    url: `${api.getBrandDetail}`,
    method: 'get',
    params
  })
}

/**
 * @description 新增品牌
 */
export function addBrand (data) {
  return request({
    url: `${api.addBrand}`,
    method: 'post',
    data
  })
}

/**
 * @description 编辑品牌
 */
export function modifyBrand (data) {
  return request({
    url: `${api.modifyBrand}`,
    method: 'post',
    data
  })
}

/**
 * @description 删除品牌
 */
export function deleteBrand (params) {
  return request({
    url: `${api.deleteBrand}`,
    method: 'get',
    params
  })
}

/**
 * @description 区域层级列表接口
 */
export function getZoneLayerList (data) {
  return request({
    url: `${api.getZoneLayerList}`,
    method: 'get',
    data
  })
}

/**
 * @description 新增区域
 */
export function addZone (data) {
  return request({
    url: `${api.addZone}`,
    method: 'post',
    data
  })
}

/**
 * @description 删除区域
 */
export function deleteZone (params) {
  return request({
    url: `${api.deleteZone}`,
    method: 'get',
    params
  })
}

/**
 * @description 修改区域
 */
export function modifyZone (data) {
  return request({
    url: `${api.modifyZone}`,
    method: 'post',
    data
  })
}

/**
 * @description 获取区域详情
 */
export function getZoneDetail (data) {
  return request({
    url: `${api.getZoneDetail}`,
    method: 'get',
    data
  })
}

/**
 * @description 图片上传接口
 */
export function uploadPic (data) {
  return request({
    url: `${api.zzgCommonUploadPic}`,
    method: 'post',
    data
  })
}

// 收款账号管理模块
/**
 * @description 收款账号列表
 */
export function getPayAccountList (data) {
  return request({
    url: `${api.getPayAccountList}`,
    method: 'post',
    data
  })
}

/**
 * @description 收款账号关联门店
 */
export function getPayAccountShopList (data) {
  return request({
    url: `${api.getPayAccountShopList}`,
    method: 'post',
    data
  })
}

/**
 * @description 收款账号变更日志
 */
export function getPayAccountUpdateLog (data) {
  return request({
    url: `${api.getPayAccountUpdateLog}`,
    method: 'post',
    data
  })
}

/**
 * @description 获取手机验证码
 */
export function getSmsCode (params) {
  return request({
    url: `${api.getSmsCode}`,
    method: 'get',
    params
  })
}

/**
 * @description 获取图形验证码
 */
export function getPicCode (data) {
  return request({
    url: `${api.getPicCode}`,
    method: 'get',
    data
  })
}

/**
 * @description 更换手机号
 */
export function updatePhone (data) {
  return request({
    url: `${api.updatePhone}`,
    method: 'post',
    data
  })
}

/**
 *
 */
export function unboundMerchantId (data) {
  return request({
    url: `${api.unboundMerchantId}`,
    method: 'post',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】获取门店列表
 */
export function chainGetShopList (data) {
  return request({
    url: `${api.chainGetShopList}`,
    method: 'post',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】获取激活码列表
 */
export function activeCodeList (data) {
  return request({
    url: `${api.activeCodeList}`,
    method: 'get',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】获取激活码列表
 */
export function chainShopCreate (data) {
  return request({
    url: `${api.chainShopCreate}`,
    method: 'post',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】补全门店资料
 */
export function chainShopUpdate (data) {
  return request({
    url: `${api.chainShopUpdate}`,
    method: 'post',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】门店创建继续进件关联商户
 */
export function chainShopRelativeMerchant (data) {
  return request({
    url: `${api.chainShopRelativeMerchant}`,
    method: 'post',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】创建门店短信接口
 */
export function chainSmsCode (params) {
  return request({
    url: `${api.chainSmsCode}`,
    method: 'get',
    params
  })
}

/**
 * 【连锁-代理商后台-品牌】集团品牌列表
 */
export function chainGroupBrandList (data) {
  return request({
    url: `${api.chainGroupBrandList}`,
    method: 'post',
    data
  })
}

/**
 * 【连锁-代理商后台-门店】获取门店详情
 */
export function getChainShopInfo (params) {
  return request({
    url: `${api.getChainShopInfo}`,
    method: 'get',
    params
  })
}
